import { createStore } from 'redux';
import { Reducers } from '../reducers';
import { devToolsEnhancer } from 'redux-devtools-extension';

export const Store = createStore(Reducers, devToolsEnhancer());